'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dBase64$002dString$0024$0024anon$002437 from "./presto.types$-Base64-String$$anon$37.js";
var $p;
/** @constructor */
function $c_Lpresto_types$Base64String$() {
  this.c44 = null;
  this.c45 = false;
  this.c42 = null;
  this.c43 = false;
  this.c46 = null;
  this.c47 = false;
}
export { $c_Lpresto_types$Base64String$ as $c_Lpresto_types$Base64String$ };
$p = $c_Lpresto_types$Base64String$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$Base64String$;
/** @constructor */
function $h_Lpresto_types$Base64String$() {
}
export { $h_Lpresto_types$Base64String$ as $h_Lpresto_types$Base64String$ };
$h_Lpresto_types$Base64String$.prototype = $p;
$p.nO = (function() {
  if ((!this.c45)) {
    this.c44 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aD;
    this.c45 = true;
  }
  return this.c44;
});
$p.r2 = (function() {
  if ((!this.c43)) {
    this.c42 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().aa;
    this.c43 = true;
  }
  return this.c42;
});
$p.cIS = (function() {
  if ((!this.c47)) {
    this.c46 = new $j_presto$002etypes$0024$002dBase64$002dString$0024$0024anon$002437.$c_Lpresto_types$Base64String$$anon$37(this);
    this.c47 = true;
  }
  return this.c46;
});
var $d_Lpresto_types$Base64String$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$Base64String$, "presto.types$Base64String$", ({
  Yu: 1,
  D: 1
}));
export { $d_Lpresto_types$Base64String$ as $d_Lpresto_types$Base64String$ };
var $n_Lpresto_types$Base64String$;
function $m_Lpresto_types$Base64String$() {
  if ((!$n_Lpresto_types$Base64String$)) {
    $n_Lpresto_types$Base64String$ = new $c_Lpresto_types$Base64String$();
  }
  return $n_Lpresto_types$Base64String$;
}
export { $m_Lpresto_types$Base64String$ as $m_Lpresto_types$Base64String$ };
//# sourceMappingURL=presto.types$-Base64-String$.js.map
